<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
import {maintenanceData} from "@/data";

export default {
  name: 'MaintenanceView',
  data(){
    return {
      data:maintenanceData
    }
  }
}
</script>
<style lang="scss" scoped></style>
